import { FormControl, MenuItem, Select } from "@mui/material";

const purposeOptions = [
  "Issued for Review",
  "Issued for Approval",
  "Issued for Construction",
  "As-Built",
];
export const docsColumns = (onChangePurpose) => [
  {
    accessorKey: "docNum",
    header: "Doc #",
    size: 30, // Reduced width
  },
  { accessorKey: "document", header: "Description", size: 60 },
  {
    accessorKey: "revNum",
    header: "Rev #",
    size: 30, // Reduced width
  },
  {
    accessorKey: "purpose",
    header: "Purpose",
    size: 80,
    muiTableBodyCellProps: { sx: { maxWidth: 100, p: 0 } },
    Cell: ({ row, cell }) => (
      <FormControl variant="standard" sx={{ width: "100%" }}>
        <Select
          value={cell.getValue()}
          onChange={() => onChangePurpose(row.original.id, cell.getValue())}
          fullWidth
          name="purpose"
          sx={{
            "& .MuiSelect-select": {
              p: 0.5,
              px: 1,
            },
          }}
        >
          {purposeOptions.map((opt) => {
            return (
              <MenuItem value={opt} key={opt}>
                {opt}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    ),
  },
  {
    accessorKey: "docLink",
    header: "Link",
    size: 30, // Reduced width
    Cell: ({ cell }) => (
      <a href={cell.getValue()} target="_blank" rel="noopener noreferrer">
        Link
      </a>
    ),
  },
];
